import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from '../analytics/analytics.service';
import { environment } from 'src/environments/environment';
import { EventName } from '../analytics/event-names';
import { HttpService } from '../http/http.service';
import { BootupData } from '../../api/wager/schemas/bootup';
import { WagerApi } from '../../api/wager/wager-api';

@Injectable({
  providedIn: 'root',
})
export class BootupService {
  private httpService = inject(HttpService);
  private analyticsService = inject(AnalyticsService);
  private bootupData: BootupData | undefined;

  async initialise() {
    this.bootupData = await WagerApi.request(this.httpService, this.analyticsService).bootup();
    this.analyticsService.log(EventName.BootupRequestSuccess);

    const minWidgetVersion =
      environment.deployment === 'inhouse'
        ? (this.bootupData.minInHouseWidgetVersion ?? 0)
        : (this.bootupData.minOperatorWidgetVersion ?? 0);
    if (minWidgetVersion > environment.build) {
      location.reload();
    }
  }
}
